import {WinPresentationController} from "../WinPresentationController";
import {WalkOfShame} from "../../WalkOfShame";
import {WalkOfShameGameMode} from "../../server/WalkOfShameGameMode";
import {WalkOfShameParsedGameData} from "../../server/data/WalkOfShameParsedGameData";
import {WalkOfShameSymbol} from "../../symbol/WalkOfShameSymbol";
import {TimelineLite} from "gsap";
import {WalkOfShameSound} from "../../sound/WalkOfShameSound";
import {WalkOfShameSymbolState} from "../../symbol/WalkOfShameSymbolConfig";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin(): boolean {
        const data: WalkOfShameParsedGameData = WalkOfShame.model.parsedGameData;
        return (data.mode !== WalkOfShameGameMode.FREESPIN && data.nextMode === WalkOfShameGameMode.FREESPIN) || ((data.mode === WalkOfShameGameMode.NORMAL || data.mode === WalkOfShameGameMode.FREESPIN) && data.nextMode.indexOf(WalkOfShameGameMode.SUPER_FREESPIN) > -1);
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            WalkOfShameSound.switchMusic({
                name: WalkOfShameSound.getMusicNameByMode(WalkOfShame.model.parsedGameData.nextMode),
                volume: 1
            });

            WalkOfShameSound.soundPlayer.playTrack({
                name: WalkOfShameSound.S1_POP_UP
            });
        }, 0);

        WalkOfShame.model.parsedGameData.scatterPositions.forEach((symId: number, reelId: number) => {
            if (symId > -1) {
                const symbol: WalkOfShameSymbol = WalkOfShame.reels[reelId].getSymbol(symId);

                tl.add(symbol.getStateAnimation(WalkOfShameSymbolState.WIN), 0);
            }
        });

        await tl;
        await new Promise<void>(resolve => {
            WalkOfShame.freespinIntro.show(() => {
                WalkOfShame.keypadPlugin.setZeroBetSpinCounter(WalkOfShame.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}